//import React from 'react';
import { useStateValue } from '../../_global/jsx/store';
import { ModalSection } from './ModalSection.jsx';


export const Modal = () => {

    const [{ modalData }, dispatch] = useStateValue([]);

    // Listen for when the modal is open, add class to body and add keydown listener
    React.useEffect(() => {
        if (modalData.showModal === true) {
            setFocusOnModal();
            document.querySelector('body').classList.add('modal--open');
            document.addEventListener("keydown", trapTabKey, false);
        } else {
            document.querySelector('body').classList.remove('modal--open');
            document.removeEventListener("keydown", trapTabKey, false);
        }

    });

    // Dipatch event to close modal and call the close callback if there is one
    const closeModal = (event) => {
        event.preventDefault();
        if (modalData['closeCallback']) {
            modalData['closeCallback']();
        }
        dispatch({
            type: 'modalToggleClick'
        })

        // Return focus state
        //setFocusOnElement(return_element);

        //this_component['context']['helpers'].closeModal(event);
        // Remove body class
        // document.querySelector('body').classList.remove('modal--open');
    }

    // Click handler for the a backround click
    const backgroundClickHandler = (event) => {
        if (event.target.classList[0] === 'appModal__wrapper') {
            event.preventDefault();
            closeModal(event);
        }
    }

    // Sets the focus on the supplied target_element, used when we open the modal
    const setFocusOnElement = (target_element) => {
        // Send user to destination element
        target_element["tabIndex"] = -1;
        target_element.focus();
        target_element["tabIndex"] = 0;
    }

    // Sets the Focus on the Modal content, used when we open the modal
    const setFocusOnModal = () => {
        var target_element = document.querySelector('.appModal__content');
        setFocusOnElement(target_element);
    }


    const returnModalContent = () => {
        return (
            <div className="appModal__content">
                <div className="appModal__header">
                    <span className="appModal__title">{modalData['title']}</span>
                    <a href="#" className="appModal__close" onClick={closeModal}></a>
                </div>
                <ModalSection content={modalData['content']} buttons={returnModalButtons()} />
            </div>
        );
    }


    // Dispatches event to show the confirm restart modal 
    const showConfirmRestartModal = () => {
        dispatch({
            type: 'showConfirmRestartModal',
            value: 'no-modal',
            callback: dispatchRestartEvent
        });

    }

    // Dispatches event to restart the app
    const dispatchRestartEvent = () => {
        dispatch({
            type: 'restart',
            value: 'no-modal'
        });
    }

    // Returns the buttons for the modal
    const returnModalButtons = () => {        
        let modal_buttons = modalData['buttons']
        let buttons_markup = null;

        if (Array.isArray(modal_buttons)) {

            buttons_markup = modal_buttons.map((button, key) => {                
                let action;
                //if the action is custom
                if (button.action === 'custom') {
                    //if the click handler is 'restart' make the click action show the confirm restart modal
                    if (typeof button.clickHandler === 'string') {
                        if (button.clickHandler === 'restart') {
                            action = showConfirmRestartModal;
                        }
                    } else if (typeof button.clickHandler === 'function') {
                        action = button.clickHandler;
                    }
                } else {
                    action = closeModal;
                }

                return (
                    <button key={key} className={button['class']} onClick={action}>{button['label']}</button>
                );
            });
        }

        return buttons_markup;
    }

    // Returns the Modal
    const returnModal = () => {

        let modalWidthClass = modalData.wideModal ? ' appModal--wide' : '';
        
        if (modalData.showModal === true) {
            return <div className={"appModal__wrapper " + modalData.additionalClass} onClick={backgroundClickHandler}>
                <div className={"appModal" + modalWidthClass}>
                    <div className="appModal__container">
                        {returnModalContent()}
                    </div>
                </div>
            </div>
        }

    }

    // Listen for and trap the keyboard    
    const trapTabKey = (e) => {
        let modalContainer = document.querySelector('.appModal__container');
        if(modalContainer !== null){
            let modalContent = document.querySelector('.appModal__content');
            let firstTabStop = modalContainer.querySelector('.appModal__close');
            let allFocusableElements = modalContainer.querySelectorAll('a, button');
            let lastTabStop = allFocusableElements[allFocusableElements.length - 1];
            // Check for TAB key press
            if (e.keyCode === 9) {
                // SHIFT + TAB
                if (e.shiftKey) {
                    if (document.activeElement === firstTabStop || document.activeElement === modalContent) {
                        e.preventDefault();
                        lastTabStop.focus();
                    }
                    // TAB
                } else {
                    if (document.activeElement === lastTabStop) {
                        e.preventDefault();
                        firstTabStop.focus();
                    }
                }
            }
            // ESCAPE
            if (e.keyCode === 27) {
                closeModal(e);
            }
        }
    }

    return (
        <>
            {returnModal()}
        </>
    )
}
